import { useNavigate } from "react-router-dom";
import { AppWindow, Globe } from "@phosphor-icons/react";
import { SectionCards } from "../components/SectionCards";

const SECTIONS = [
  { id: "app", title: "APP", icon: AppWindow, color: "#38BDF8", desc: "Monitoraggio collegamenti, dati e database delle webapp", testId: "monitor-section-app", to: "/monitor/app" },
  { id: "siti", title: "SITI", icon: Globe, color: "#E9A23B", desc: "Monitoraggio SEO dei siti dell'ecosistema", testId: "monitor-section-siti", to: "/monitor/siti" },
];

export default function MonitorPage() {
  const navigate = useNavigate();

  return (
    <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8 sm:py-12" data-testid="monitor-page">
      <div className="mb-8 animate-fade-up">
        <p className="text-xs tracking-[0.3em] uppercase text-white/40 mb-2">Controllo dell'ecosistema</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tighter leading-none">Monitor</h1>
        <p className="text-sm text-slate-400 mt-3">Clicca una card per aprire la sezione corrispondente.</p>
      </div>

      <SectionCards sections={SECTIONS} active={null} onSelect={(s) => navigate(s.to)} />
    </main>
  );
}
